document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".hgp-collection-slider");

    if (!slider) return;

    const prevBtn = document.querySelector(".hgp-slider-prev");
    const nextBtn = document.querySelector(".hgp-slider-next");

    const cards = slider.querySelectorAll(".hgp-collection-card");

    if (!cards.length) return;
 
    // -------------------------------------
    // Reveal Animation
    // -------------------------------------

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("show");

            observer.unobserve(entry.target);

        });

    }, {

        threshold: 0.15

    });

    cards.forEach((card, index) => {

        card.style.transitionDelay = `${index * 80}ms`;

        observer.observe(card);

    });

    // -------------------------------------
    // Arrow Visibility
    // -------------------------------------

    function updateButtons() {

        const maxScroll = slider.scrollWidth - slider.clientWidth;

        // No overflow
        if (maxScroll <= 2) {

            prevBtn.classList.remove("show");
            nextBtn.classList.remove("show");

            return;
        }

        // Left button
        if (slider.scrollLeft <= 5) {

            prevBtn.classList.remove("show");

        } else {

            prevBtn.classList.add("show");

        }

        // Right button
        if (slider.scrollLeft >= maxScroll - 5) {

            nextBtn.classList.remove("show");

        } else {

            nextBtn.classList.add("show");

        }

    }

    // -------------------------------------
    // Scroll Amount
    // -------------------------------------

    function getScrollAmount() {

        const firstCard = cards[0];

        const gap = parseInt(getComputedStyle(slider).columnGap || getComputedStyle(slider).gap || 18);

        return firstCard.offsetWidth + gap;

    }

    nextBtn.addEventListener("click", () => {

        slider.scrollBy({

            left: getScrollAmount(),

            behavior: "smooth"

        });

    });

    prevBtn.addEventListener("click", () => {

        slider.scrollBy({

            left: -getScrollAmount(),

            behavior: "smooth"

        });

    });

    slider.addEventListener("scroll", updateButtons);

    window.addEventListener("resize", updateButtons);

    updateButtons();

});